import { render, staticRenderFns } from "./OldDataAlertIcon.vue?vue&type=template&id=9c4ac288&"
import script from "./OldDataAlertIcon.vue?vue&type=script&lang=ts&"
export * from "./OldDataAlertIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
